<div class="chart-container">
  <canvas #barChartCanvas class="barChart"></canvas>
</div>
